import * as actionTypes from '../Global_action.types';

const initialState = {
  loggingIn: false,
  companyDetails: [],
  error: null,
  message: '',
};


const companyDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CREATE_COMPANY_DETAILS_REQUEST:
    case actionTypes.GET_COMPANY_DETAILS_REQUEST:
    case actionTypes.UPDATE_COMPANY_DETAILS_REQUEST:
    case actionTypes.DELETE_COMPANY_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.CREATE_COMPANY_DETAILS_SUCCESS:
    case actionTypes.UPDATE_COMPANY_DETAILS_SUCCESS:
    case actionTypes.DELETE_COMPANY_DETAILS_SUCCESS:
    case actionTypes.GET_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        clients: action.payload,
      };
    case actionTypes.GET_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        clients: action.payload,

      }

    case actionTypes.CREATE_COMPANY_DETAILS_FAILURE:
    case actionTypes.GET_COMPANY_DETAILS_FAILURE:
    case actionTypes.UPDATE_COMPANY_DETAILS_FAILURE:
    case actionTypes.DELETE_COMPANY_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default companyDetailsReducer
